module.exports = __webpack_public_path__ + "img/itx-human-resources-hierarchy-add.35de0bd2.svg";